
const pages = {
  filers: [
    {
      title: 'Browse Filers',
      href: '/Filers/',
    },
    {
      title: 'Filer Listings',
      href: '/FilerListing',
    },
    {
      title: 'Recently Organized',
      href: '/Filers/RecentlyOrganized',
    },
    {
      title: 'Filer Types & Filing Schedules',
      href: '/Filers/FilerTypes',
    }
  ],
  legal: [
    {
      title: 'Legal Resources',
      href: '/legal',
    },
    {
      title: 'Contribution Limits',
      href: '/legal/contributionlimits',
    },
    {
      title: 'Agency Actions',
      href: '/Legal/AgencyActions',
    },
    {
      title: 'Campaign Finance Law',
      href: '/Legal/CampaignFinanceLaw',
    },
    {
      title: 'Regulations: 970 CMR',
      href: '/Legal/Regulations',
    }
  ],
  reports: [
    {
      title: 'All Report Lists',
      href: '/reports/',
    },
    {
      title: 'Real Time Report Filings',
      href: '/reports/log',
    },
    {
      title: 'Search Campaign Finance Data',
      href: '/reports/searchItems',
    }
  ],
  data: [
    {
      title: 'Search Campaign Finance Data',
      href: '/Data/SearchItems',
    },
    {
      title: 'OCPF Data Center',
      href: '/Data',
    },
    {
      title: 'Monthly Fundraising Charts',
      href: '/Data#monthly-charts',
    },
    {
      title: 'Statewide Ballot Question Charts',
      href: '/Data/BallotQuestionsElection',
    },
    {
      title: 'Massachusetts Governor Race Charts',
      href: '/Data/GovernorElection',
    },
    {
      title: 'Download Data',
      href: '/Data/Downloads',
    }
  ],
  forms: [
    {
      title: 'OCPF Forms',
      href: '/Publications/Forms',
    },
    {
      title: 'Guides, Studies & Publications',
      href: '/Publications',
    },
    {
      title: 'Campaign Finance Training',
      href: '/Municipal/TreasurerTrainings',
    }
  ],
  clerk: [
    {
      title: 'Municipal Clerk Support',
      href: '/Municipal',
    },
    {
      title: 'Municipal Forms',
      href: '/Publications/Forms?search=municipal',
    },
    {
      title: 'Getting Local Filers Started',
      href: '/Municipal#getting-started',
    },
    {
      title: 'Election Schedule Calculator',
      href: '/Municipal#election-calculator',
    },
    {
      title: 'Town & City Map',
      href: '/Municipal/Map',
    },
    {
      title: 'Ballot Disqualification',
      href: '/Municipal/BarredFilers',
    }
  ],
  about: [
    {
      title: 'About OCPF',
      href: '/About/AboutOcpf',
    },
    {
      title: 'Director Message',
      href: '/About/Message',
    },
    {
      title: 'Bank Support',
      href: '/About/BankSupport',
    },
    {
      title: 'Career',
      href: '/About/JobPostings',
    },
    {
      title: 'Contact Us',
      href: '/About/ContactUs',
    },
    {
      title: 'Accessibility Statement',
      href: '/About/AccessibilityStatement',
    },
  ],
};

export default pages;
